import React, { useState } from "react";
import s from "./styles.module.css";
import Card from "@mui/material/Card";
import { Select, MenuItem, CardActionArea } from "@mui/material";
import { IconButton } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../FormatDate";
import ShowModal from "../Modal/ShowModal/ShowModal";
import { toast } from "react-toastify";
import { endpointMap } from "../../../data/Fields";
import TransferModal from "../Modal/TransferModal/TransferModal";
import ImageSlider from "./imageSlider/ImageSlider";
import useAuth from "../../../hooks/useAuth";

export default function CardComponent({ item }) {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState("");
  const { auth } = useAuth();
  const userRole = auth?.role;
  const [isTransferModalOpen, setIsTransferModalOpen] = useState(false);

  const handleSelectChange = (event) => {
    const action = event.target.value;
    setSelectedAction(action);

    if (action === "appoint") {
      setIsModalOpen(true);
    } else if (action === "transfer") {
      setIsTransferModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedAction("");
  };

  const handleConfirm = () => {
    setIsModalOpen(false);
    setSelectedAction("");
  };
  const endpointType = endpointMap[item?.property_type] || "UnknownType";

  const handleShareClick = () => {
    const url = `https://admin.bmgroup.kg/objectDetails/${endpointType}/${item?.property_id}`;
    navigator.clipboard.writeText(url).then(
      () => {
        toast.success("Ссылка скопирована!");
      },
      (err) => {
        console.error("Ошибка копирования: ", err);
      },
    );
  };

  return (
    <Card sx={{ width: 400, position: "relative" }}>
      <CardActionArea
        onClick={() =>
          navigate(`/objectDetails/${endpointType}/${item?.property_id}`)
        }
      >
        <div
          style={{
            position: "absolute",
            top: 8,
            left: 8,
            backgroundColor: "white",
            color: "black",
            padding: "4px 8px",
            borderRadius: "5px",
            fontSize: "12px",
            zIndex: 1000,
          }}
        >
          ID: {item?.id}
        </div>

        {item?.photos && item.photos.length > 0 ? (
          <div style={{ height: 250, marginBottom: 15 }}>
            <ImageSlider
              images={item.photos.map(
                (photo) =>
                  `${process.env.REACT_APP_API_URL}/api/v1/property/${photo.image_url.replace("/photos/", "")}`,
              )}
            />
          </div>
        ) : (
          <img
            src="https://серебро.рф/img/placeholder.png"
            alt="property"
            style={{
              width: "100%",
              height: 250,
              objectFit: "cover",
              marginBottom: 15,
            }}
          />
        )}
        <div className={s.cardContentWrapper}>
          <p className={s.descriptionTitle}>
            {[
              item?.property_type === "Дома и участки"
                ? item?.land_type
                : item?.property_type,
              item?.description,
              item?.residential?.name,
            ]
              .filter(Boolean)
              .join(", ")}
          </p>

          <p className={s.cardLocation}>
            <img src="/icons/cardLoc.svg" alt="icons" />
            <span>{item?.district?.name}</span>
          </p>

          <h2
            style={{
              fontWeight: 600,
              fontSize: 20,
              color: "rgba(160, 111, 19, 1)",
              marginBottom: 10,
            }}
          >
            $ {item?.price}
          </h2>

          <div className={s.cardAgentWrapper}>
            <p className={s.cardAgentInfo}>
              <img src="/icons/cardAgent.svg" alt="icons" />
              <span>{item?.agent?.name}</span>
            </p>
            <span className={s.cardTime}> {formatDate(item?.created_at)}</span>
          </div>
        </div>
      </CardActionArea>
      <div className={s.buttonBlock}>
        <div>
          <IconButton aria-label="share" onClick={handleShareClick}>
            <ShareIcon />
          </IconButton>
        </div>
        <Select
          value={selectedAction}
          onChange={handleSelectChange}
          displayEmpty
          sx={{ ".MuiSelect-select": { padding: "8px 15px" } }}
        >
          <MenuItem value="">Действия</MenuItem>
          <MenuItem value="appoint">Назначить показ</MenuItem>
          {userRole === "admin" && (
            <MenuItem value="transfer">Перенос объекта</MenuItem>
          )}
        </Select>
      </div>

      {isModalOpen && (
        <ShowModal
          open={isModalOpen}
          onClose={handleCloseModal}
          onConfirm={handleConfirm}
          id={item?.id}
        />
      )}

      {isTransferModalOpen && (
        <TransferModal
          open={isTransferModalOpen}
          onClose={() => setIsTransferModalOpen(false)}
          onConfirm={() => setIsTransferModalOpen(false)}
          propertyId={item?.property_id}
          endpointType={endpointType}
        />
      )}
    </Card>
  );
}
